exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-0ade6d20]{width:100%}.wrapper .dropdown.typeahead[data-v-0ade6d20]{width:calc(100% - 1.4em);position:absolute}.wrapper .dropdown.typeahead .dropdown-menu[data-v-0ade6d20]{width:100%}.wrapper .dropdown.typeahead .dropdown-menu .dropdown-content[data-v-0ade6d20]{max-height:20em;overflow-y:scroll}.wrapper .dropdown.typeahead .dropdown-menu .dropdown-content a.dropdown-item[data-v-0ade6d20]{text-overflow:ellipsis;overflow-x:hidden;padding-right:1em}.wrapper .control.has-icons-right .icon.clear-button[data-v-0ade6d20]{pointer-events:all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ade6d20","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/enso/bulma/Typeahead.vue
// module id = sLo6
// module chunks = 66